<template>
  <div>
    <b-img
      v-for="(ods_item, key) in ods"
      :key="key"
      :src="'https://odsbrasil.gov.br/content/ods/' + ods_item.id + '.png'"
      v-bind="mainProps"
      rounded
      :alt="ods_item.name"
      class="img_ods img-thumbnail"
      :class="{ img_not_selected: !is_selected(ods_item.id) }"
      @click="select_ods(ods_item.id)"
    ></b-img>
  </div>
</template>

<script>
import { findIndex } from "lodash";
import { mapState, mapActions } from "vuex";

export default {
  props: {},
  data: () => ({
    mainProps: {
      blankColor: "#777",
    },
  }),
  computed: {
    ...mapState("oportunidades", ["oportunidade", "ods"]),
    selected: {
      get() {
        return this.oportunidade.ods.map((ods) => ods.id);
      },
      set(value) {
        this.oportunidade.ods = value;
      },
    },
  },
  methods: {
    ...mapActions("oportunidades", ["ActionShow", "ActionGetOds"]),
    is_selected(id) {
      return findIndex(this.oportunidade.ods, ["id", id]) >= 0;
    },
    select_ods(id) {
      if (!this.is_selected(id)) {
        this.oportunidade.ods.push({ id: id });
      } else {
        const index = findIndex(this.oportunidade.ods, ["id", id]);
        this.oportunidade.ods.splice(index, 1);
      }
      this.$emit("change", this.oportunidade.ods);
    },
  },
  async created() {
    await this.ActionGetOds();
  },
};
</script>

<style scoped>
.img_ods {
  transition: all 0.3s;
  cursor: pointer;
  min-width: 5%;

  width: 110px;
  height: 110px;
  margin: 0.1rem !important;
  padding: 0.1rem !important;
}
.img_not_selected {
  filter: grayscale(100%);
  opacity: 0.5;
}
</style>
